import { render } from "./Rating.vue?vue&type=template&id=4436190f"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"

import "./Rating.vue?vue&type=style&index=0&id=4436190f&lang=css"
script.render = render

export default script